import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo/Seo";
import styles from "./NotFound.module.css";

export function NotFoundPage() {
  return (
    <>
      <Seo
        title="Page not found"
        description="The page you're looking for could not be found."
        path="/404"
        noindex
      />
      <section className={`section ${styles.wrap}`}>
        <div className="container">
          <p className="eyebrow">404</p>
          <h1>This page wandered off the estate.</h1>
          <p className={styles.lede}>
            The page you're looking for doesn't exist or has moved. Let's get you
            back to Villa Rosa.
          </p>
          <Link to="/" className="btn btn--primary">
            Return home
          </Link>
        </div>
      </section>
    </>
  );
}
